import { render, staticRenderFns } from "./TopicList.vue?vue&type=template&id=8d778aac"
import script from "./TopicList.vue?vue&type=script&lang=js"
export * from "./TopicList.vue?vue&type=script&lang=js"
import style0 from "./TopicList.vue?vue&type=style&index=0&id=8d778aac&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports